import { render, staticRenderFns } from "./ProjectCostsSummaryTable.vue?vue&type=template&id=2971d340&scoped=true&"
import script from "./ProjectCostsSummaryTable.vue?vue&type=script&lang=js&"
export * from "./ProjectCostsSummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2971d340",
  null
  
)

export default component.exports